import { createBaseSelectors, centsToFormattedString } from '@navinc/utils'
import { createSelector } from 'reselect'

const baseSelectors = createBaseSelectors()
const { getData } = baseSelectors

const parseDate = (rawDate) => {
  if (!rawDate) return ''
  const date = new Date(rawDate)
  const year = date.getFullYear()
  // Add 1 to the month bc JS
  const month = (date.getMonth() + 1).toString().padStart(2, '0')
  const day = date.getDate().toString().padStart(2, '0')

  return { day, month, year }
}

const parseDashDate = (rawDate) => {
  const parsedDate = parseDate(rawDate)
  if (!parsedDate) return ''
  const { day, month, year } = parsedDate
  return `${year}-${month}-${day}`
}

const parseSlashDate = (rawDate) => {
  const parsedDate = parseDate(rawDate)
  if (!parsedDate) return ''
  const { day, month, year } = parsedDate
  return `${month}/${day}/${year}`
}

const parseTransaction = ({ created_at: date, amount_cents: amount, message: status }) => ({
  date: parseSlashDate(date),
  amount: centsToFormattedString(amount),
  status,
})

const getAddress = createSelector(getData, (data) => data?.payment_method ?? {})

const getPaymentMethodLast4 = createSelector(getData, (data) => data?.payment_method?.last_four ?? '')

const getPlanCode = createSelector(getData, (data) => data?.plan_code ?? '')

const getNextBillingCycle = createSelector(
  getData,
  (data) => data?.data?.next_billing_cycle_at ?? '',
  (data, date) => parseDashDate(date)
)

const getSubscribedOn = createSelector(
  getData,
  (data) => data?.data?.subscribed_at ?? '',
  (data, date) => parseDashDate(date)
)

const getTransactions = createSelector(
  getData,
  (data) => data?.data?.transactions ?? [],
  (data, transactions) => transactions.map((transaction) => parseTransaction(transaction))
)

export const selectors = {
  ...baseSelectors,
  getAddress,
  getPaymentMethodLast4,
  getPlanCode,
  getNextBillingCycle,
  getSubscribedOn,
  getTransactions,
}
